import { useLocales } from '@sevenrooms/locales'
import type { ModalHeaderProps } from '@sevenrooms/ui-kit/layout'
import { reservationWidgetMessages } from '../../../reservationWidgetMessages'
import { CallVenueMessage } from '../../CallVenueMessage'
import { NotificationModal } from '../NotificationModal'

interface UnableCancelModalProps {
  closeHref: NonNullable<ModalHeaderProps['closeHref']>
}

export function UnableCancelModal({ closeHref }: UnableCancelModalProps) {
  const { formatMessage } = useLocales()

  return (
    <NotificationModal
      type="warning"
      title={formatMessage(reservationWidgetMessages.resCancelPageUnableCancelModifyResHeader)}
      primary={<CallVenueMessage />}
      closeHref={closeHref}
      data-test="unable-cancel-modal"
    />
  )
}
